import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Stats from "@/pages/Stats";
import ProstaVive from "@/pages/ProstaVive";
import NitricBoost from "@/pages/NitricBoost";
import Home from "@/pages/Home";
import Legal from "@/pages/Legal";
import Kit from "@/pages/Kit";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Spotlight } from "@/components/site/Spotlight";
import { Bento } from "@/components/site/Bento";
import { Ritual } from "@/components/site/Ritual";
import { Lead } from "@/components/site/Lead";
import { Featured } from "@/components/site/Featured";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";

const SmoothScroll = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, anchors: true });
    lenis.scrollTo(0, { immediate: true });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, [pathname]);
  return null;
};

function Landing() {
  return (
    <main className="bg-[#091D18]" data-testid="landing-page">
      <Nav />
      <Hero />
      <Marquee />
      <Spotlight />
      <Bento />
      <Ritual />
      <Lead />
      <Featured />
      <Faq />
      <Footer />
      <Toaster position="bottom-center" />
    </main>
  );
}

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/joint-genesis" element={<Landing />} />
        <Route path="/prostavive" element={<ProstaVive />} />
        <Route path="/nitric-boost" element={<NitricBoost />} />
        <Route path="/stats" element={<Stats />} />
        <Route path="/kit" element={<Kit />} />
        <Route path="/:slug" element={<Legal />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
